<template>
  <WdsModal :show="show" no-close-icon :title="title" class="modal-confirmation">
    <WdsText secondary>{{ text }}</WdsText>
    <template #footer>
      <div class="tw-flex tw-items-center tw-justify-end tw-gap-md">
        <WdsButton @click="emit('secondaryButtonClick')">{{ secondaryButtonText }}</WdsButton>
        <WdsButton primary @click="emit('primaryButtonClick')">{{ primaryButtonText }}</WdsButton>
      </div>
    </template>
  </WdsModal>
</template>

<script setup lang="ts">
import { WdsButton, WdsModal, WdsText } from '@worksome/wds-components'

const emit = defineEmits(['primaryButtonClick', 'secondaryButtonClick'])

const props = defineProps<{
  show: boolean
  title: string
  text: string
  primaryButtonText: string
  secondaryButtonText: string
}>()
</script>

<style scoped lang="scss">
.modal-confirmation {
  :deep(.wds-modal-content) {
    @apply tw-mt-10;
  }
  :deep(.wds-modal-body) {
    @apply tw-mt-0;
  }
}
</style>
